import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable()
export class DxMissingTranslationHandler implements MissingTranslationHandler {
  public missingTranslation = {};

  handle(params: MissingTranslationHandlerParams): any {
    const propertyKeys = params.key.split('.');
    if (propertyKeys.length > 1 && propertyKeys[0][0] === propertyKeys[0][0].toUpperCase()) {
      this.addToMissing(propertyKeys, this.missingTranslation);
    }
  }

  public addToMissing(propertyKeys: string[], missingTranslation): void {
    const propertyKey = propertyKeys.shift();
    if (!missingTranslation.hasOwnProperty(propertyKey)) {
      missingTranslation[propertyKey] = {};
    }
    if (propertyKeys.length) {
      this.addToMissing(propertyKeys, missingTranslation[propertyKey]);
    } else {
      missingTranslation[propertyKey] = '';
    }
  }
}
